/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAppInfoGet } from '../fn/app/api-app-info-get';
import { ApiAppInfoGet$Params } from '../fn/app/api-app-info-get';

@Injectable({ providedIn: 'root' })
export class AppService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAppInfoGet()` */
  static readonly ApiAppInfoGetPath = '/api/App/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAppInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAppInfoGet$Response(params?: ApiAppInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiAppInfoGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAppInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAppInfoGet(params?: ApiAppInfoGet$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiAppInfoGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
